export default "__VITE_ASSET__YutREF6m__"